import 'client-only';

import { logger } from '@curology/logger/client';
import { v4 } from 'uuid';

import { type Brand } from '@/consts/brands';
import COOKIE_KEYS from '@/consts/cookieKeys';
import cookies from '@/utils/cookies/client';
import { post } from '@/utils/http/client';
import { utmParams } from '@/utils/http/client/utmParams';
import { isDefined } from '@/utils/isDefined';
import { urls } from '@/utils/urls';

const hasValidUtmParams = () => {
  const { source, medium, name } = utmParams();

  return [source, medium, name].filter((utmParam) => !!utmParam).length > 1;
};

const hasValidReferrer = () => !!document.referrer;

const getUuid = () => {
  const queryParams = new URLSearchParams(window.location.search);
  if (queryParams.has('uuid')) {
    return queryParams.get('uuid');
  }

  const ldUuid = cookies.get(COOKIE_KEYS.ldUuid);
  if (isDefined(ldUuid)) {
    return ldUuid;
  }

  return v4();
};

const setUuid = () => {
  if (cookies.has(COOKIE_KEYS.curologyUuid)) return;

  const uuid = getUuid();
  const days = 1000;

  if (uuid) {
    cookies.set(COOKIE_KEYS.curologyUuid, uuid, { expires: days });
  }
};

export const reportReferrerUtm = (brand: Brand) => {
  setUuid();

  const curologyUuid = cookies.get(COOKIE_KEYS.curologyUuid);

  if (isDefined(curologyUuid) && (hasValidUtmParams() || hasValidReferrer())) {
    post(urls[brand].api.referrerUtms.store, {
      uuid: curologyUuid,
      landing_page_url: window.location.href,
      referrer_url: document.referrer,
      user_agent: (!!window.navigator && window.navigator.userAgent) || '',
    }).catch((error) => {
      logger.log(`Failed to report UTM/Referrer: ${error}`);
    });
  }
};
